import * as Sentry from "@sentry/react";

import config from "./config";
import { isFeatureEnabled } from "./flags";

if (isFeatureEnabled(import.meta.env.VITE_SENTRY_ENABLED)) {
  Sentry.init({
    dsn: config.sentryDSN,
    autoSessionTracking: true,
    integrations: [Sentry.browserTracingIntegration()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    environment: import.meta.env.MODE,
  });
}
